import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { QaiButtonComponent, QaiCallButtonComponent, QaiCallTimerComponent, QaiIconComponent } from '@qai/ui';

@Component({
  imports: [
    CommonModule,
    QaiCallButtonComponent,
    QaiCallTimerComponent,
    TranslocoModule,
    QaiIconComponent,
    QaiButtonComponent
  ],
  selector: 'app-call-footer',
  standalone: true,
  styleUrls: ['./call-footer.css'],
  templateUrl: './call-footer.html',
})
export class CallFooterComponent {
  @Input({ required: true }) isCaptionsOn = false;
  @Input({ required: true }) time = '';
  @Input({ required: true }) isPaused = false;
  @Input({ required: true }) showPauseButton = false;
  @Input({ required: true }) isPauseEnabled = false;
  @Input({ required: true }) isRealTimeCall = false;
  @Input({ required: true }) showContinueButton = false;

  @Output() readonly settingsClicked = new EventEmitter();
  @Output() readonly captionsClicked = new EventEmitter();
  @Output() readonly playbackClicked = new EventEmitter();

  protected handleSettingsClick() {
    this.settingsClicked.emit();
  }

  protected handleCaptionsClick() {
    this.captionsClicked.emit();
  }

  protected handlePlaybackClick() {
    this.playbackClicked.emit();
  }
}
